// extracted by mini-css-extract-plugin
module.exports = {"scrollBarHidden":"allAnnouncement_scrollBarHidden_2P3Ze"};